"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPropertyPrimaryTruthy = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var RadioButtonChecked_1 = __importDefault(require("@mui/icons-material/RadioButtonChecked"));
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var hasPropertyPrimary = function (value) {
    return typeof value === 'object' && value !== null && 'primary' in value;
};
var hasPropertyPrimaryTruthy = function (value) {
    if (hasPropertyPrimary(value) && typeof value.primary === 'boolean') {
        return value.primary;
    }
    return false;
};
exports.hasPropertyPrimaryTruthy = hasPropertyPrimaryTruthy;
function ArrayFieldMenu(_a) {
    var value = _a.value, onlyOneValue = _a.onlyOneValue, checkPrimary = _a.checkPrimary, dropOrErase = _a.dropOrErase, pushNewElement = _a.pushNewElement;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ "aria-label": t('ds.arrayField.show'), id: "long-button", "aria-controls": open ? 'long-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "true", onClick: handleClick }, { children: (0, jsx_runtime_1.jsx)(MoreVert_1.default, {}) })), (0, jsx_runtime_1.jsxs)(material_1.Menu, __assign({ id: "long-menu", MenuListProps: {
                    'aria-labelledby': 'long-button',
                }, anchorEl: anchorEl, open: open, onClose: handleClose }, { children: [hasPropertyPrimary(value) && ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ onClick: checkPrimary, disabled: value.primary }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(RadioButtonChecked_1.default, { fontSize: "small" }) }), t('ds.arrayField.primary')] }))), (0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ onClick: dropOrErase }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(Delete_1.default, { fontSize: "small" }) }), t('ds.arrayField.delete')] })), !onlyOneValue && ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ onClick: pushNewElement }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(Add_1.default, { fontSize: "small" }) }), t('ds.arrayField.add')] })))] }))] }));
}
exports.default = ArrayFieldMenu;
ArrayFieldMenu.defaultProps = {
    onlyOneValue: false,
};
//# sourceMappingURL=ArrayFieldMenu.js.map